import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/64_card_back_snowflakes/64_card_back_snowflakes"
 * Contains 1 texture(s)
 */
export class CardsBacks64CardBackSnowflakesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/64_card_back_snowflakes/64_card_back_snowflakes';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '64_snowflakes.png'
    ] as const;
}
